<template>
<b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9" class="border">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Modelo</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link :to="{ name: 'BrandListModels' }">Modelos por Marca</b-link> &raquo; <b-link :href="'/models-by-brand/model/'+ model.slug">Lista de Modelos de {{ model.brand }}</b-link> &raquo; {{model.name}}:
                </b-col>
              </b-row>
              <div class="mt-2"></div>
              <div class="pb-2 cliente-detalle mb-4">
                    <b-row>
                      <b-col cols="12" class="text-left pr-4 pl-4">
                        <label>Nombre:</label> <strong>{{model.name}}</strong><br>
                        <label>Marca:</label> <strong>{{model.brand}}</strong><br>
                        <label>Slug:</label> <strong>{{model.slug}}</strong><br>
                        <label>Imagen:</label> <strong>{{model.image}}</strong><br>
                        <div v-if="model.status==1">
                          <label>Estado:</label> <strong>Activo</strong><br>
                        </div>
                        <div v-else>
                          <label>Estado:</label> <strong>Inactivo</strong><br>
                        </div>
                      <label>Creado en:</label> <strong>{{model.created_at}}</strong><br>
                      </b-col>
                    </b-row>
                <hr class="my-4">
                <b-btn variant="success" @click.stop="editmodel(model._id)">Editar</b-btn>
                <b-btn variant="danger" @click.stop="deletemodel(model._id)">Eliminar</b-btn>
              </div>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from 'axios'
import Header from './Header'
import Menu from './Menu'
export default {
  name: 'ShowModel',
  components:{
    Header,
    Menu
  },
  data () {
    return {
      model: []
    }
  },
  created () {
    if(localStorage.getItem('role')=="Administrador"){
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`/models/` + this.$route.params.id)
      .then(response => {
        this.model = response.data
        document.title = "Administración Derco - Oficina " + response.data.name
      })
      .catch(e => {
        this.errors.push(e)
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    editmodel (modelid) {
      this.$router.push({
        name: 'EditModel',
        params: { id: modelid }
      })
    },
    deletemodel (modelid) {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.delete('/models/' + modelid)
      .then((result) => {
        this.$router.push({
          name: 'ModelsListByBrand',
          params: { brand: this.model.brand }
        })
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>

<style>
  .jumbotron {
    padding: 2rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/ShowModel.vue